export interface MomReview {
  id: number;
  campId: number;
  parentName: string;
  childAge: number;
  rating: number;
  reviewText: string;
}

export const momReviews: MomReview[] = [
  {
    id: 1,
    campId: 2,
    parentName: 'Sarah',
    childAge: 9,
    rating: 5,
    reviewText: 'My son did this camp last summer and LOVED it. The instructors were amazing and he came home excited every day.',
  },
  {
    id: 2,
    campId: 2,
    parentName: 'Jessica',
    childAge: 11,
    rating: 5,
    reviewText: 'Absolutely incredible experience. My daughter went from knowing nothing about coding to building her own game in one week. We are signing up again!',
  },
  {
    id: 3,
    campId: 4,
    parentName: 'Michelle',
    childAge: 8,
    rating: 5,
    reviewText: 'The coaches were so patient and encouraging. My son improved so much in just one week and made great friends too.',
  },
  {
    id: 4,
    campId: 4,
    parentName: 'Tanya',
    childAge: 7,
    rating: 4,
    reviewText: 'Great camp overall! My daughter had a blast and the end-of-week tournament was so fun to watch as a parent.',
  },
  {
    id: 5,
    campId: 5,
    parentName: 'Amanda',
    childAge: 6,
    rating: 5,
    reviewText: 'Such a warm and welcoming environment. My kids came home singing worship songs every day. We will definitely be back next summer!',
  },
  {
    id: 6,
    campId: 6,
    parentName: 'Renee',
    childAge: 10,
    rating: 5,
    reviewText: 'As a mom of a child with special needs, finding this camp was a blessing. The staff truly understood my son and made him feel included and celebrated.',
  },
  {
    id: 7,
    campId: 7,
    parentName: 'Brittany',
    childAge: 15,
    rating: 5,
    reviewText: 'My teenager came back from this camp a completely different kid — more confident, more focused, and already asking to go back next year.',
  },
  {
    id: 8,
    campId: 9,
    parentName: 'Keisha',
    childAge: 12,
    rating: 5,
    reviewText: 'The video analysis sessions were a game changer. My son could actually see what he needed to fix and improved so fast. Highly recommend!',
  },
  {
    id: 9,
    campId: 10,
    parentName: 'Lauren',
    childAge: 8,
    rating: 5,
    reviewText: 'My daughter came home with the coolest projects and could not stop talking about the experiments. She is already asking to go back!',
  },
  {
    id: 10,
    campId: 11,
    parentName: 'Danielle',
    childAge: 12,
    rating: 4,
    reviewText: 'My tween had an absolute blast zip-lining and kayaking. She was nervous at first but the counselors were so encouraging. Worth every penny.',
  },
  {
    id: 11,
    campId: 12,
    parentName: 'Monica',
    childAge: 10,
    rating: 5,
    reviewText: 'The Friday performance had me in tears — in the best way! My daughter shone on that stage and the whole production was so impressive for one week of camp.',
  },
  {
    id: 12,
    campId: 12,
    parentName: 'Priya',
    childAge: 13,
    rating: 5,
    reviewText: 'My son has been doing this camp for three summers now. The quality of instruction keeps getting better and the community is wonderful.',
  },
  {
    id: 13,
    campId: 62,
    parentName: 'Tamara',
    childAge: 7,
    rating: 5,
    reviewText: 'My son talks about this camp all year long. The energy is incredible and the instructors genuinely care about every single kid.',
  },
  {
    id: 14,
    campId: 62,
    parentName: 'Nikki',
    childAge: 9,
    rating: 5,
    reviewText: 'Best camp in Gwinnett, hands down. My daughter built so much confidence and came home exhausted in the best possible way every single day.',
  },
  {
    id: 15,
    campId: 36,
    parentName: 'Christine',
    childAge: 16,
    rating: 5,
    reviewText: 'This program completely changed my daughter\'s perspective on college. She came home motivated, inspired, and already researching engineering programs.',
  },
];
